import React from "react";
import "./cricket.m.css";

function Result({ result }) {
  const rows = result;

  if (!rows.length) return null;
  const data = rows[0];
  const url = "/sport/cricket/ilt20-match-center";
  return (
    <div styleName="result">
      <div styleName="title">
        <div styleName="icon">
          <img src="https://images.assettype.com/gulfnews-uat/2025-11-27/olitz4s6/dp-world.png" />
        </div>
        {/* <div styleName="name"></div> */}
        <div styleName="is-result">
          <div styleName="result-dot-tag">
            <span styleName="tag">RESULT</span>
          </div>
        </div>
      </div>
      <a href={url + "?id=" + data.match_id}>
        <div styleName="result-item">
          <div styleName="res-txt">{data.short_event_status}</div>
        </div>
      </a>
    </div>
  );
}
export default Result;
